import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import budgeting from '../../assets/img/finance/anggaran.png';
import bookkeeping from '../../assets/img/bookkeeping/jurnal_bank.png';

export default class Library extends PureComponent {
  constructor(props) {
    super(props);
    this.onClickDataPerpus = this.onClickDataPerpus.bind(this);
    this.onClickBookkeping = this.onClickBookkeping.bind(this);
  }

  onClickDataPerpus() {
    const { history } = this.props;
    history.push('/dashboard/perpustakaan/data-perpustakaan');
  }

  onClickBookkeping() {
    const { history } = this.props;
    history.push('/dashboard/keuangan/pembukuan');
  }

  render() {
    return (
      <div className="finance">
        <div className="finance__list">
          <button onClick={this.onClickDataPerpus}>
            <img src={budgeting} alt="DataPerpus" />
            <h3>Data Perpustakaan</h3>
          </button>
        </div>
      
      </div>
    );
  }
}
Library.propTypes = {
  history: PropTypes.object.isRequired,
};
